import * as React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';

import List from './Components/List';

export default class extends React.PureComponent {

  static propTypes = {
    componentWillMount: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
  }

  componentWillMount = () => this.props.componentWillMount(this.props);

  render () {

    const { onClose } = this.props;

    return (
        
      <Modal
        visible  
        title="Item Descriptions"
        width={1000}
        onCancel={onClose}
        footer={null}
      >
        
        <List />

      </Modal>
      
    )
  }
}